export const MANUAL_QUANTITY_INSTRUMENT_ISIN = 'IRX6XTSX0006';
